import { Size } from '../types';
export const generateName = ({
    size,
    position,
    uuid
}: {
    size: Size;
    position: number;
    uuid?: string;
}): string => {
    return `dfp_${
        typeof size === 'string' ? size : size.join('x')
    }_${position}${uuid ? `_${uuid}` : ''}`;
};
